export default "__VITE_ASSET__DTGaN1H$__"